export const APP_ROUTES = {
  ROOT: '/',
  COACH: {
    MAIN: '/coach',
    MEMBER: '/coach/members/:memberUuid',
    COMPANY: '/coach/companies/:companyUuid',
    TEAM: '/coach/companies/:companyUuid/teams/:teamUuid',
  },
  DASHBOARD: '/dashboard',
  DASHBOARD_V2: '/dashboard/command-center',
  DASHBOARD_CLASSIC: '/dashboard/classic',
  SETTINGS: {
    MAIN: '/settings',
    PROFILE: '/settings/profile',
    COACHING: '/settings/coaching',
    KNOWLEDGE_BASE: '/settings/knowledge-base',
    LANGUAGE: '/settings/language',
    COMPANY_CONTROLS: '/settings/company-controls',
    BILLING: '/settings/billing',
    INTEGRATIONS: '/settings/integrations',
    SECURITY: '/settings/security',
    COMMANDER: '/settings/piloteer-commander',
  },
  AUTH: {
    MAIN: '/auth',
    LOGIN: '/auth/login',
    SIGNUP: '/auth/signup',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    VERIFY_EMAIL: '/auth/verify-email',
    SET_PASSWORD: '/auth/set-password',
  },
  REPORTS: {
    MAIN: '/reports',
    MEETINGS: '/reports?tab=meetings',
    SESSIONS: '/reports?tab=sessions',
  },
  MEETINGS: {
    MAIN: '/meetings', // Keep for backward compatibility
    SLUG: '/meetings/:uuid',
  },
  SESSIONS: {
    MAIN: '/sessions', // Keep for backward compatibility
    SLUG: '/sessions/:uuid',
  },
  INVALID_CLIENT: '/invalid-client',
  OAUTH_CALLBACK: {
    ZOOM: '/oauth-callback/zoom',
    GOOGLE: '/oauth-callback/google',
    MICROSOFT: '/oauth-callback/microsoft',
  },
  // Multi-tenant routes - Simplified
  PARTNER: {
    DASHBOARD: '/partner',
    COMPANY_DETAIL: '/partner/companies/:uuid',
    ONBOARD_COMPANY: '/partner/companies/onboard',
    SETTINGS: '/partner/settings',
  },
  COMPANY: {
    TEAMS: '/company/teams',
    TEAM_DETAIL: '/company/teams/:uuid',
    USERS: '/company/users',
    KNOWLEDGE_BASE: '/company/knowledge-base',
    SETTINGS: '/company/settings',
    LANGUAGE_SETTINGS: '/company/settings/language',
  },
  TEAM: {
    DASHBOARD: '/team',
    DETAIL: '/team/:uuid',
  },
  // Super Admin routes
  SUPER_ADMIN: {
    LOGIN: '/super-admin/login',
    DASHBOARD: '/super-admin',
    PARTNERS: '/super-admin/partners',
    COMPANIES: '/super-admin/companies',
    USERS: '/super-admin/users',
    COACHES: '/super-admin/coaches',
    APP_CONFIG: '/super-admin/app-config',
    CLIENTS: '/super-admin/clients',
    OPERATIONS: '/super-admin/operations',
  },
  // Analytics routes
  ANALYTICS: {
    MY: '/analytics/me',
    TEAM: '/analytics/team/:teamId',
    COMPANY: '/company/analytics',
    PARTNER: '/partner/analytics',
    PARTNER_COMPANY: '/partner/analytics/company/:companyUuid',
  },
};
